import { api, multipartApi } from './networkService';

class UserService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/user`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch user error:', error);
            throw error;
        }
    }

    static async fetchAll() {
        try {
            const response = await api.get(`api/user/user`);
            return response.data;
        } catch (error) {
            console.error('Fetch user error:', error);
            throw error;
        }
    }

    static async fetchAllSupervisors() {
        try {
            const response = await api.get(`api/user/user`, {
                params: {
                    type: 'supervisor'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch user error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/user/one/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch user error:', error);
            throw error;
        }
    }

    static async add(user) {
        try {
            const response = await multipartApi.post(`api/user/user`, user);
            return response;
        } catch (error) {
            console.error('Add user error:', error);
            throw error;
        }
    }

    static async update(id, user) {
        try {
            const response = await multipartApi.put(`api/user/user/one/${id}`, user);
            return response;
        } catch (error) {
            console.error('Update user error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/user/one/${id}`);
            return response;
        } catch (error) {
            console.error('Delete user error:', error);
            throw error;
        }
    }
}

export default UserService;
